import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, StyledEngineProvider, createTheme, adaptV4Theme } from '@mui/material/styles';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { muiGlobalTheme } from '../FormElements.theme';
import Label from '../Label';

function Radios({ activeRadio, isStacked, name, radios, onChange, labelPlacement, checkedIcon, icon, styles }) {
  const theme = {
    ...muiGlobalTheme,
    overrides: {
      MuiRadio: { root: { height: 44, marginBottom: 0 } },
      MuiFormControlLabel: {
        root: {
          alignItems: 'flex-start',
          ...styles
        }
      }
    }
  };
  const radioTheme = createTheme(adaptV4Theme(theme));

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={radioTheme}>
        {radios.map(radio => (
          <Fragment key={`rad-${radio.value}`}>
            <FormControlLabel
              control={
                <Radio
                  checked={activeRadio === radio.value}
                  color="primary"
                  key={`rad-${radio.value}`}
                  name={name}
                  onChange={onChange}
                  value={radio.value}
                  {...checkedIcon && { checkedIcon }}
                  {...icon && { icon }}
                />
              }
              disabled={radio.isDisabled}
              key={`fcl-${radio.value}`}
              label={<Label label={radio.label} description={radio.description} toolTip={radio.toolTip} />}
              labelPlacement={labelPlacement}
            />
            {isStacked && <br />}
          </Fragment>
        ))}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

Radios.propTypes = {
  activeRadio: PropTypes.string,
  isStacked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  styles: PropTypes.objectOf(PropTypes.string),
  labelPlacement: PropTypes.string,
  checkedIcon: PropTypes.element,
  icon: PropTypes.element,
  radios: PropTypes.arrayOf(
    PropTypes.shape({
      isDisabled: PropTypes.bool,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      description: PropTypes.string,
      toolTip: PropTypes.node
    })
  ).isRequired
};

Radios.defaultProps = {
  activeRadio: '',
  isStacked: false,
  onChange: () => {},
  styles: {},
  labelPlacement: '',
  checkedIcon: null,
  icon: null
};

export default Radios;
